import Roles from "@/modules/core/service/private/Roles";
import Vue from 'vue';

export  default {
    load (store, force) {
        return this.loadPreferences(store, force)
            .then(() => Promise.all([
                this.initIncidentEnums(store, force),
                this.initCrmFilters(store, force),
                this.initMasterDataEnums(store, force),
                this.initInboxEnums(store, force),
                this.initDmsEnums(store, force),
                this.initReportEnums(store, force),
                this.initAudits(store, force),
                this.initDisposition(store, force)
            ]))
            .catch(error => {
                const i18n = Vue.prototype.$i18n;
                const message = error?.message || i18n.t('common.error.generic');
                Vue.prototype.$bus.$emit(Vue.prototype.$events.alert.error, { message });
            });
    },

    loadPreferences (store, force) {
        if (store.getters.preferences && !force) {
            return Promise.resolve();
        }

        return store.dispatch("findPreferences");
    },

    initInboxEnums (store, force) {
        if (store.getters.messageTypes && !force) {
            return Promise.resolve();
        }

        if (Roles.liftmanager()) {
            return store.dispatch('initInboxEnums');
        }

        return Promise.resolve();
    },

    initDmsEnums (store, force) {
        if (store.getters.dms && !force) {
            return Promise.resolve();
        }

        return store.dispatch('initDmsEnums');
    },

    initIncidentEnums (store, force) {
        if (store.getters.incidenttypes && !force) {
            return Promise.resolve ();
        }

        return store.dispatch('initIncidentEnums');
    },

    initCrmFilters (store, force) {
        if (store.getters.crmFilter && !force) {
            return Promise.resolve ();
        }

        return store.dispatch('initCrmFilter');
    },

    initReportEnums (store, force) {
        if (store.getters.reportDefinitions && !force) {
            return Promise.resolve();
        }

        return store.dispatch('initReportEnums');
    },

    initMasterDataEnums (store, force) {
        if (store.getters.msd && !force) {
            return Promise.resolve();
        }

        return store.dispatch('initMasterDataEnums');
    },

    initAudits (store, force) {
        if (store.getters.audit && !force) {
            return Promise.resolve();
        }

        return store.dispatch('initAuditEnums');
    },

    initDisposition (store, force) {
        if (store.getters.disposition && !force) {
            return Promise.resolve();
        }

        return store.dispatch('initDispositionEnums');
    },
}